// datetime의 date picker에 병합하여 더이상 업데이트하지 않음 (이미 사용하고 있는 곳이 있기 때문에 모듈은 유지)
import moment from 'moment/moment'
import store from '@/stores/'
import UNIQUE from '@/common/unique'

const langValue = function (val) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = val
  })
  return obj
}

const dayOfWeek = [
  { id: 'mon', name: '월', available: true, weekday: 2 },
  { id: 'tue', name: '화', available: true, weekday: 3 },
  { id: 'wed', name: '수', available: true, weekday: 4 },
  { id: 'thu', name: '목', available: true, weekday: 5 },
  { id: 'fri', name: '금', available: true, weekday: 6 },
  { id: 'sat', name: '토', available: true, weekday: 7 },
  { id: 'sun', name: '일', available: true, weekday: 1 }
]

export default {
  id: 'calendar',
  name: 'calendar',
  type: 'action',
  moduleName: 'editor_module_calendar',
  dataSet: {
    mods: 'calendar',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'calendar',
        value: langValue('calendar')
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'calendar',
      isRequired: true,
      label: langValue('calendar'),
      labelValue: 'calendar',
      hasTerm: false,
      dateFrom: new Date().toISOString(),
      dateTo: moment().add(5, 'day').toISOString(),
      dayOfWeek: dayOfWeek,
      disabledDays: [],
      allowedToday: true,
      allowedPast: false,
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
